import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { initializeFirebase } from "@/firebase"; // Import your Firebase initialization
import {useAppDispatch} from "@/hooks/reducer-hooks";
import {setUserDetails} from "@/slices/userSlice";

function PrivateRoute({ children }) {
    const [loading, setLoading] = useState(true);
    const [authenticated, setAuthenticated] = useState(false);
    const dispatch = useAppDispatch()

    useEffect(() => {
        // Initialize Firebase
        const { auth } = initializeFirebase();

        // Check the authentication state
        const unsubscribe = auth.onAuthStateChanged((user) => {
            if (user) {
                dispatch(setUserDetails(user));
            }
            setAuthenticated(!!user);

            setLoading(false);
        });

        return () => unsubscribe();
    }, []);

    if (loading) {
        return <p>Loading...</p>;
    }
    return authenticated ? children : <Navigate to="/" />;
}

export default PrivateRoute;
